import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@chakra-ui/react";
import { PlanType } from "sdk/types";
import { MembershipSelectAction } from "../hooks";
import { useGetPlanDetailsMap } from "../hooks/useGetPlanDetailsMap";

interface Props {
  action: MembershipSelectAction;
  handleClick: () => void;
  type: PlanType;
  variant?: "th-primary" | "th-secondary";
}

export const PlanCta: FC<Props> = ({
  action,
  handleClick,
  type,
  variant = "th-secondary",
}) => {
  const { t } = useTranslation();
  const planDetailsMap = useGetPlanDetailsMap({
    action,
    handleClick,
    type,
  });
  const buttonProps = planDetailsMap[type][action];
  const ctaText = t(`planSelect.${action}.${type}.cta`);

  if (!ctaText) return null;

  return (
    <Button
      fontWeight="bold"
      minW="248px"
      size="th-md"
      variant={variant}
      w="full"
      {...buttonProps}
    >
      {t(`planSelect.${action}.${type}.cta`)}
    </Button>
  );
};
